import controller from './controller';
import headerScene from './scenes/header';
import parallaxImage from './scenes/parallax-image';
import simpleRevealer from './scenes/simple-revealer';
import stripesRevealer from './scenes/stripes-revealer';
import counterScene from './scenes/counter';
import scrollToTopScene from './scenes/scrollToTop';

export {
  controller,
  headerScene,
  parallaxImage,
  simpleRevealer,
  stripesRevealer,
  counterScene,
  scrollToTopScene,
};



// WEBPACK FOOTER //
// ./components/_scrollmagic/index.js